module.exports = __webpack_public_path__ + "img/help-file.7dd50b80.svg";